module.exports = __webpack_public_path__ + "static/media/nadu-logo-full.4f8f9649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nadu-logo-full.png
// module id = 582
// module chunks = 0